import { Form, Checkbox } from "antd";

import { isBoolean } from "../../../../../modules/dataFunctions";

const { Item } = Form;

const CheckboxItem = ({
  formItemLayout,
  checkboxLabel,
  initialValue,
  wrapperCol,
  fieldName,
  className,
  onChange,
  disabled,
  labelCol,
  label,
  error,
}) => (
  <Item
    help={error}
    label={label}
    name={fieldName}
    valuePropName="checked"
    className={`two-rows-label ${className}`}
    initialValue={isBoolean(initialValue) ? initialValue : undefined}
    labelCol={labelCol ? { span: labelCol } : formItemLayout.labelCol}
    wrapperCol={wrapperCol ? { span: wrapperCol } : formItemLayout.wrapperCol}
  >
    <Checkbox onChange={onChange} disabled={disabled}>
      {checkboxLabel}
    </Checkbox>
  </Item>
);

export default CheckboxItem;
